package pwgs.ui.scenes.playerconfigscene

import pwgs.ui.scenes.custompropertieseditorscene.CustomPropertiesEditorScene
import pwgs.ui.scenes.custompropertieseditorscene.CustomPropertiesEditorSceneProps
import pwgs.ui.scenes.trialsettingsscene.TrialSettingsScene
import pwgs.ui.scenes.trialsettingsscene.TrialSettingsSceneProps
import visage.core.Components
import visage.ds.components.page.Page

fun Components.PlayerConfigScene(projectId: Long) = this.registerFunctionalComponent({}) {
    Page {
        head("Player Configuration")
        tab("Custom properties") {
            CustomPropertiesEditorScene(CustomPropertiesEditorSceneProps(projectId, "Player"))
        }
        tab("Trial season") {
            TrialSettingsScene(TrialSettingsSceneProps(projectId))
        }
    }
}